import classNames from "classnames";
import * as React from "react";
import { Progress, toPercent } from "../../../domains/LearningMaterialProgress";
import { ProgressBar } from "../../atoms/ProgressBar";
import styles from "./styles.scss";

interface Props {
  progress: Progress;
}

const StudyScheduleProgressBar = (props: Props): React.ReactElement<any> => {
  const percent = toPercent(props.progress);
  return (
    <ProgressBar
      value={percent}
      className={classNames({
        [styles.ltHalf]: percent < 50,
        [styles.gteqHalf]: percent >= 50,
        [styles.completed]: percent >= 100,
      })}
    />
  );
};

export default StudyScheduleProgressBar;
